import PropTypes from 'prop-types';

export const ConnectionPropTypes = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

export const ConnectionsPropTypes = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});
